import {
  first,
  includes,
  intersection,
  isEmpty,
  keys,
  pickBy,
  reject,
  values,
} from 'lodash-es';

// this code from shop repo app/javascript/packs/shop/tw-modules/tw.translate-model.js
export default function getTranslateModel(
  input,
  lang = document.querySelector('html').getAttribute('lang'),
) {
  if (!input || isEmpty(input)) {
    return '';
  }
  if (typeof input === 'string') {
    return input;
  }

  var supported_languages = window.mainConfig.merchantData.supported_languages;

  // Required language present in given input hash
  if (includes(supported_languages, lang) && !isEmpty(input[lang])) {
    return input[lang];
  }

  // Language code that need special handling
  var available_fallbacks = [];
  switch (lang) {
    case 'zh-cn':
      available_fallbacks = intersection(keys(input), supported_languages, [
        'zh-cn',
        'zh-hant',
        'zh-hk',
        'zh-tw',
        'en',
      ]);
      break;
    case 'zh-hant':
    case 'zh-hk':
    case 'zh-tw':
      available_fallbacks = intersection(keys(input), supported_languages, [
        'zh-tw',
        'zh-hant',
        'zh-hk',
        'zh-cn',
        'en',
      ]);
      break;
    default:
      available_fallbacks = intersection(keys(input), supported_languages, [
        'en',
      ]);
  }

  function valueFromFallbackLanguages() {
    return first(
      reject(
        values(
          pickBy(input, function (v, k) {
            return includes(available_fallbacks, k);
          }),
        ),
        function (val) {
          return isEmpty(val);
        },
      ),
    );
  }

  function valueFromExistingKeys() {
    return first(
      reject(values(input), function (val) {
        return isEmpty(val);
      }),
    );
  }

  return valueFromFallbackLanguages() || valueFromExistingKeys() || '';
}
